import React, { Component } from 'react';
import moment from 'moment';
import StatisticsWithFilteredData from '../Statistics/StatisticsWithFilteredData';
import StatisticsFilter from '../StatisticsFilter/StatisticsFilter';

export default class StatisticsPage extends Component{

  constructor(props) {
    super(props);

    this.state = {
      filter_data: {
        start_date: moment().startOf('month'),
        end_date: moment().endOf('month'),
      },
    };

    this.onFilterChange = this.onFilterChange.bind(this);
  }


  componentWillMount(){

    const {app_data, history} = this.props;

    const role = app_data.roles[app_data.user.role_id];

    if(!role.access.leads) {
      history.push(role.default_page);
    }

  }

  onFilterChange(data) {
    this.setState({
      filter_data: data
    });
  }

  render() {

    const {app_data} = this.props;
    const role = app_data.roles[app_data.user.role_id];

    const {filter_data} = this.state;
    const showFIlter = role.access.leads.remove;
    return (
      <div className={`container`}>
        <h1>Обращения</h1>

        <StatisticsFilter
          app_data={app_data}
          filter_data={this.state.filter_data}
          onFilterChange={this.onFilterChange}
          {...{
            ...(showFIlter ? {} : {
              minDate: moment().add(-2, 'months').startOf('month')
            })
          }}
        />
        

        {filter_data &&
          <StatisticsWithFilteredData app_data={app_data} filter_data={filter_data} />
        }
      </div>
    );
  }
}

